// Shared Centralized Dataset for BS CLADS

export const companyDetails = {
  name: "bs clads",
  brandName: "bs clads",
  tagline: "SINCE 2010",
  contactPerson: "raj vikram das",
  distributorContact: "V.S. Maheswaran",
  phoneNumbers: {
    primary: "+91 81443 70659",

  },
  email: "rajvikramdas@bsclads.com",
  website: "www.bsclads.com",
  officeAddress: "2112, Opp. to TVH Apartments, Trichy Road, Singanallur, Coimbatore - 641 005",
  factoryAddress: "2015, Louis Philippe Back side, Trichy Road, Singanallur, Coimbatore - 641 005",
  mapLink: "https://www.google.com/maps?q=10.9980847,77.0148584&z=17&hl=en",
  colors: {
    green: "#f03a02", // Primary Accent Color #f03a02
    orange: "#E85B24"
  }
};

export const partnerBrands = {
  acp: [
    { name: "Eurobond", logoText: "EUROBOND", tag: "Premium ACP Panels" },
    { name: "Aludecor", logoText: "ALUDECOR", tag: "Architectural Metal Composite" }
  ],
  glass: [
    { name: "Saint-Gobain", logoText: "SAINT-GOBAIN", tag: "High-Performance Facade Glazing" }
  ]
};

export const productsData = [
  {
    id: "acp-front-elevation",
    slug: "acp-front-elevation",
    title: "ACP Front Elevation",
    subtitle: "Aluminum Composite Panel Front Elevation",
    category: "ACP Front Elevation",
    image: require('../images/products/acp_cladding.jpg'),
    mainImage: require('../images/products/acp_cladding.jpg'),
    shortDesc: "High-grade weather-resistant ACP sheet front elevation for modern building exteriors, showroom facades, and interior wall paneling.",
    description: "Premium Aluminum Composite Panel (ACP) front elevation systems engineered for extreme weather resistance, lightweight structural support, and sophisticated metallic aesthetics on building facades by BS CLADS.",
    features: [
      "PVDF / FEVE Weatherproof Coating",
      "Fire-Retardant Mineral Core Options",
      "Extreme Thermal & Acoustic Insulation",
      "CNC Router Custom Panel Fabrication",
      "Lightweight Structural Sub-Framing",
      "10+ Years Color Stability Guarantee"
    ],
    specifications: [
      { key: "Panel Thickness", value: "3mm, 4mm, 6mm" },
      { key: "Aluminum Skin Thickness", value: "0.25mm, 0.30mm, 0.50mm" },
      { key: "Coating Type", value: "PVDF 2-Coat / 3-Coat Kynar 500" },
      { key: "Standard Panel Sizes", value: "1220mm x 2440mm, 1220mm x 3050mm, 1500mm x 3660mm" },
      { key: "Fire Rating", value: "Class B1 / Class A2 Fire Retardant" },
      { key: "Brand Partners", value: "Eurobond, Aludecor" }
    ]
  },
  {
    id: "facade-glazing",
    slug: "facade-glazing",
    title: "Facade Glazing",
    subtitle: "Structural Glass Facade & Curtain Wall Systems",
    category: "Facade Glazing",
    image: require('../images/products/facade_glazing.jpg'),
    mainImage: require('../images/products/facade_glazing.jpg'),
    shortDesc: "Modern facade glazing systems designed for a clean architectural finish, strong performance, and long-lasting durability.",
    description: "Architectural glass curtain wall systems designed to maximize natural interior lighting while ensuring optimal UV protection, solar heat control, and high wind resistance by bs clads.",
    features: [
      "Frameless Structural Glazing & Spider Fittings",
      "High Light Transmittance & Solar Heat Control",
      "Double Glazed Unit (DGU) Insulation",
      "High Wind Load Structural Design",
      "Acoustic Soundproofing Glass Configurations",
      "Structural Silicone Weather Sealing"
    ],
    specifications: [
      { key: "Glass Options", value: "Toughened, Laminated, Low-E DGU, Solar Control" },
      { key: "Glass Thickness", value: "6mm, 8mm, 10mm, 12mm, 24mm DGU" },
      { key: "Fittings", value: "SS 316 Spider Fittings, Aluminum Mullions & Transoms" },
      { key: "Sealant Grade", value: "Structural Silicone Weatherproof Sealants" },
      { key: "Wind Pressure Rating", value: "Engineered up to 2.5 kPa" },
      { key: "Brand Partners", value: "Saint-Gobain Glass" }
    ]
  },
  {
    id: "toughened-glass",
    slug: "toughened-glass",
    title: "Toughened Glass",
    subtitle: "High-Strength Safety Glass Elevation & Partitions",
    category: "Toughened Glass",
    image: require('../images/products/structural_glazing.jpg'),
    mainImage: require('../images/products/structural_glazing.jpg'),
    shortDesc: "Toughened Glass is a strong and durable safety glass designed for better strength, safety, and long-lasting performance in modern building applications.",
    description: "Thermal and mechanical safety glass processed to withstand 4x to 5x higher impact resistance than standard annealed glass.",
    features: [
      "5x Thermal Impact Resistance",
      "High Structural Load Bearing Capacity",
      "Safe Fragment Breaking Pattern",
      "Custom Edging, Drilling & Cut-Outs",
      "Ideal for Glass Railings, Canopy & Shopfronts",
      "UV & Scratch Resistant Surface"
    ],
    specifications: [
      { key: "Thickness Range", value: "5mm to 19mm Toughened Glass" },
      { key: "Glass Types", value: "Clear, Extra Clear Low-Iron, Tinted, Frosted" },
      { key: "Edge Finishing", value: "Flat Polish, Beveled, Arris Polish" },
      { key: "Compliance", value: "IS 2553 / EN 12150 Safety Standard" }
    ]
  }
];

export const projectsData = [
  {
    id: "acp-front-elevation-five-star-towers",
    slug: "acp-front-elevation-five-star-towers",
    title: "ACP Front Elevation - Five Star Towers",
    category: "ACP Front Elevation",
    client: "Five Star Estate",
    location: "Trichy Road, Singanallur, Coimbatore",
    year: "2026",
    image: require('../images/products/acp_cladding.jpg'),
    summary: "Modern tower front elevation using metallic champagne gold ACP composite panel cladding with anti-corrosive aluminum sub-framing.",
    description: "bs clads delivered full fabrication, CNC tray panel shaping, and installation for this 5-story complex on Trichy Road, Singanallur."
  },
  {
    id: "facade-glazing-showroom",
    slug: "facade-glazing-showroom",
    title: "Facade Glazing & Showroom Elevation",
    category: "Facade Glazing",
    client: "Luxury Automobile Showroom",
    location: "Trichy Road, Coimbatore",
    year: "2025",
    image: require('../images/products/facade_glazing.jpg'),
    summary: "Full structural glass facade glazing with Saint-Gobain Low-E DGU units providing clear visibility and solar heat reduction.",
    description: "High-span frameless glass elevation engineered for maximum daylight penetration and premium aesthetic appeal."
  },
  {
    id: "toughened-glass-atrium-complex",
    slug: "toughened-glass-atrium-complex",
    title: "Toughened Glass Partitions & Structural Atrium",
    category: "Toughened Glass",
    client: "Race Course Tech Park",
    location: "Race Course, Coimbatore",
    year: "2025",
    image: require('../images/products/structural_glazing.jpg'),
    summary: "12mm clear toughened glass interior atrium walls, glass railings with SS 316 spider fittings.",
    description: "Acoustically insulated glass partitions and structural glass canopy executed with precision execution."
  },
  {
    id: "singanallur-luxury-residence-front-elevation",
    slug: "singanallur-luxury-residence-front-elevation",
    title: "Singanallur Villa Front Elevation",
    category: "ACP Front Elevation",
    client: "Private Residence",
    location: "Singanallur, Coimbatore",
    year: "2026",
    image: require('../images/products/front_elevation.jpg'),
    summary: "Wood-finish and charcoal grey Eurobond ACP panel front elevation for modern luxury residence.",
    description: "Custom CNC cut accent grilles and weather-tight silicone joint sealing."
  }
];

export const statisticsData = [
  { id: 1, count: "14+", label: "Years Experience", icon: "fa-award" },
  { id: 2, count: "1100+", label: "Projects Completed", icon: "fa-building" },
  { id: 3, count: "100%", label: "Quality Assurance", icon: "fa-certificate" },
  { id: 4, count: "25+", label: "Districts Covered", icon: "fa-map-marked-alt" }
];
